export class VideoTypeDto {
  videoTypeId?: number;
  titleFrancais: string;
  titleAnglais: string;
  pathImage: string;
  urlImage: string;
}
